import * as Yup from 'yup';

export const loginValidationSchema = Yup.object({
    email: Yup.string()
        .email('Please enter a valid email address')
        .required('Email is required'),
    password: Yup.string()
        .min(6, 'Password must be at least 6 characters')
        .required('Password is required'),
});

export const registerValidationSchema = Yup.object({
    companyName: Yup.string()
        .min(2, 'Company name must be at least 2 characters')
        .required('Company name is required'),
    firstName: Yup.string()
        .min(2, 'First name must be at least 2 characters')
        .required('First name is required'),
    lastName: Yup.string()
        .min(2, 'Last name must be at least 2 characters')
        .required('Last name is required'),
    email: Yup.string()
        .email('Please enter a valid email address')
        .required('Email is required'),
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .matches(
            /^(?=.*[a-z])/,
            'Password must contain at least one lowercase letter',
        )
        .matches(
            /^(?=.*[A-Z])/,
            'Password must contain at least one uppercase letter',
        )
        .matches(/^(?=.*\d)/, 'Password must contain at least one number')
        .matches(
            /^(?=.*[!@#$%^&*()_+=[\]{};':"\\|,.<>/?-])/,
            'Password must contain at least one special character',
        )
        .test(
            'no-lt-gt',
            'Password cannot contain < or > characters',
            (value) => value && !value.includes('<') && !value.includes('>'),
        )
        .required('Password is required'),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password')], 'Passwords must match')
        .required('Please confirm your password'),
    contactNumber: Yup.string(),
    partnerCode: Yup.string(),
    approvalCode: Yup.string(),
    recaptchaToken: Yup.string(), // Now optional since collected in modal after form validation
});

export const forgotPasswordValidationSchema = Yup.object({
    email: Yup.string()
        .email('Please enter a valid email address')
        .required('Email address is required'),
});

export const changePasswordValidationSchema = Yup.object({
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .matches(
            /^(?=.*[a-z])/,
            'Password must contain at least one lowercase letter',
        )
        .matches(
            /^(?=.*[A-Z])/,
            'Password must contain at least one uppercase letter',
        )
        .matches(/^(?=.*\d)/, 'Password must contain at least one number')
        .matches(
            /^(?=.*[!@#$%^&*()_+=[\]{};':"\\|,.<>/?-])/,
            'Password must contain at least one special character',
        )
        .test(
            'no-lt-gt',
            'Password cannot contain < or > characters',
            (value) => value && !value.includes('<') && !value.includes('>'),
        )
        .required('Password is required'),
    token: Yup.string().required('Reset token is required'),
    username: Yup.string().required('Username is required'),
});
